import { Box, Grid, Typography } from "@mui/material"
import { BreadCrumb, SnackSimple } from "../../../../../../components"
import { useBreadcrumb } from "./hooks"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { CustomePanel, CustomeTab } from "../../../../../../components/customeTab"
import { useReassignUserContext } from "./context"
import { useTabList } from "./hooks/tabList"
import { ReassignUserTabs } from "./enums"
import { ManageUserFilter, Reassign, Tracking } from "./components"
import { useLayoutEffect } from "react"
import { useStyles } from "./styles"
import { TabContainerReassign, TabContainerTracking } from "./constants"

export const ReassignUser = () => {
    const { id } = useParams()
    const { t } = useTranslation()
    const styles = useStyles()
    const { changeTab, closeSnackbar, snackbar, services, tabValue } = useReassignUserContext()
    const isTracking = ReassignUserTabs.TRACKING == tabValue
    const sizeTabContainer = isTracking ? TabContainerTracking : TabContainerReassign
    const tabList = useTabList()
    const { listBreadCrumb } = useBreadcrumb()
    useLayoutEffect(() => {
        if (tabValue == ReassignUserTabs.REASSIGN) {
            services.getUsersToReassign({ id })
        }
        if (tabValue == ReassignUserTabs.TRACKING) {
            services.getAreaItems()
            services.getDepartmentItems()
            services.getRoleItems()
            services.getUserTypeItems()
        }
    }, [tabValue])
    return (
        <Box className="main-container">
            <BreadCrumb
                removeBreadcrumb={['report-folio', 'calendar', 'schedule-user']}
                replaceLabels={{
                    dashboard: 'reportFolioList',
                    detail: 'detailReportFolio'
                }}
                replacePath={{
                    detail: `/dashboard/report-folio/dashboard/detail/${id}`
                }}
                breadList={listBreadCrumb}
            />

            <Grid container spacing={3} pb={7}>
                {ReassignUserTabs.TRACKING == tabValue && (
                    <Grid item xs={4} mt={1}>
                        <Typography variant="title_grey_big">{t('reportFolio.reassignUser.title')}</Typography>

                        <ManageUserFilter />
                    </Grid>
                )}
                <Grid item xs={sizeTabContainer.xs} sx={styles.tabContainer}>
                    <CustomeTab
                        listTab={tabList}
                        value={tabValue}
                        justifyContent="end"
                        listTabContainerProps={styles.tabList({ isTracking })}
                        startChildren={!isTracking && <Typography variant="title_grey_big">{t('reportFolio.reassignUser.title')}</Typography>}
                        tabList={{ onChange: (_, value) => { changeTab({ value }) }, sx: styles.tabs }}
                    >
                        <CustomePanel value={ReassignUserTabs.REASSIGN}> <Reassign /> </CustomePanel>
                        <CustomePanel value={ReassignUserTabs.TRACKING}> <Tracking /> </CustomePanel>
                    </CustomeTab>
                </Grid>
            </Grid>

            <SnackSimple open={snackbar.open} message={snackbar.message} type={snackbar.type} close={closeSnackbar} />
        </Box>
    )
}